<template>
<div id="logos">
  <h2>Logos</h2>
  <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img src="../assets/LunaJoyasLogo.png" class="w-50 height" alt="Logo de Luna Joyas">
        <h5 class="nombre-logo"><a class="link-portfolio" target="_blank" href="https://www.instagram.com/lunajoyascba/">Luna Joyas</a></h5>
        <p>Emprendimiento de Joyería en plata en Cordoba Capital.</p>
    </div>
    <div class="carousel-item">
      <img src="../assets/PrettyWomanLogo.png" class="w-50 height" alt="Logo de Pretty Woman">
        <h5 class="nombre-logo"><a class="link-portfolio" target="_blank" href="https://www.instagram.com/prettywoman1318/">Pretty Woman</a></h5>
        <p>Centro integral de estética y manicura en Perico, Jujuy.</p>
    </div>
    <div class="carousel-item">
      <img src="../assets/VictoriaAccesoriosLogo.png" class="w-50 height" alt="Logo de Victoria Accesorios">
      <h5 class="nombre-logo"><a class="link-portfolio" target="_blank" href="https://www.instagram.com/vic.toriaccesorios/">Victoria Accesorios</a></h5>
      <p>Accesorios e indumentaria femenina en Perico, Jujuy.</p>
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls"  data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls"  data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>
</div>
 
</template>

<script>
export default {
    name: "Logos",
}
</script>

<style>
#logos{
    margin-top: 100px;
    padding: 20px;
}

.height{
  width: 50%;
  height: auto;
}

</style>